<div class="dialog-add-fields">
  <div class="title">
    Add Field
    <button (click)="close()">
      <mat-icon> clear </mat-icon>
    </button>
  </div>
  <div class="content">
    @if (availableFields.length) {
      @for (field of availableFields; track field) {
        <div class="content-field">
          {{ field.name }}
          <mat-checkbox (change)="addRemove($event, field)"></mat-checkbox>
        </div>
      }
    } @else {
      <div class="flex justify-center">No more fields to be added.</div>
    }
  </div>
  <div class="flex justify-end">
    <button class="button-confirm-field" (click)="addFields()">Add Field(s)</button>
  </div>
</div>
